// https://github.com/surveyjs/survey-library/blob/master/packages/survey-core/src/localization/japanese.ts

export const japaneseSurveyStrings = {
  pagePrevText: '前へ',
  pageNextText: '次へ',
  completeText: '完了',
  previewText: 'プレビュー',
  editText: '編集',
  startSurveyText: 'スタート',
  commentText: 'コメントを残してください',
  otherItemText: 'その他（説明）',
  noneItemText: 'なし',
  refuseItemText: '回答を拒否する',
  dontKnowItemText: 'わからない',
  selectAllItemText: 'すべて選択',
  deselectAllItemText: 'すべて選択解除',
  progressText: 'ページ{0}/{1}',
  indexText: '{1}の{0}',
  panelDynamicProgressText: '{1}の{0}を記録する',
  panelDynamicTabTextFormat: 'Panel {panelIndex}',
  questionsProgressText: '{0}/{1}問回答済',
  emptySurvey: 'アンケートに表示可能な要素がありません。',
  completingSurvey: 'アンケートにご協力いただき、ありがとうございます。',
  completingSurveyBefore: 'このアンケートはすでに回答済みです。',
  loadingSurvey: 'アンケートを読み込んでいます...',
  placeholder: '選択',
  ratingOptionsCaption: '選択。。。',
  buttongroupOptionsCaption: '選ぶ。。。',
  value: '値',
  requiredError: '回答が必要です',
  requiredErrorInPanel: '回答が必要です：少なくとも1つの質問に答えてください。',
  requiredInAllRowsError: '回答が必要です：すべての行の質問に答えてください。',
  eachRowUniqueError: '各行に一意の値を入力してください。',
  numericError: '数字でご記入下さい',
  minError: '値は {0} 以上である必要があります',
  maxError: '値は {0} 以下である必要があります',
  textNoDigitsAllow: '数字は使用できません。',
  textMinLength: '少なくとも {0} 文字を入力してください。',
  textMaxLength: '{0} 文字以内で入力してください。',
  textMinMaxLength: '{0} 文字以上 {1} 文字以内で入力してください。',
  minRowCountError: '少なくとも {0} 行を入力してください。',
  minSelectError: '少なくとも {0} 個のオプションを選択してください。',
  maxSelectError: '{0} 個以下の選択肢を選択してください。',
  numericMinMax: '\'{0}\' は {1} 以上 {2} 以下である必要があります',
  numericMin: '\'{0}\' は {1} 以上である必要があります',
  numericMax: '\'{0}\' は {1} 以下である必要があります',
  invalidEmail: '有効なメールアドレスを入力してください。',
  invalidExpression: '式: {0} は \'true\' を返す必要があります。',
  urlRequestError: 'リクエストはエラー \'{0}\' を返しました。{1}',
  urlGetChoicesError: 'リクエストが空のデータを返したか、\'path\' プロパティが正しくありません。',
  exceedMaxSize: 'ファイルのサイズは{0}を超えてはいけません',
  noUploadFilesHandler: 'ファイルはアップロードできません。「onUploadFiles」イベントのハンドラーを追加してください。',
  otherRequiredError: '回答が必要です：他の値を入力してください。',
  uploadingFile: 'ファイルをアップロード中です。しばらくしてから再度お試し下さい',
  loadingFile: '読み込み中',
  chooseFile: 'ファイルを選択',
  noFileChosen: '選択されたファイルはありません',
  filePlaceholder: 'ここにファイルをドラッグ&ドロップするか、下のボタンをクリックしてアップロードするファイルを選択してください。',
  confirmDelete: 'レコードを削除しますか？',
  keyDuplicationError: 'この値は一意でなければなりません。',
  addColumn: '列の追加',
  addRow: '追加行',
  removeRow: '削除',
  noRowsText: '行がありません。',
  rowIndexTemplateTitle: '行 {rowIndex}',
  rowNameTemplateTitle: '{rowTitle}',
  addPanel: '新規追加',
  removePanel: '削除',
  showDetails: '詳細を表示',
  hideDetails: '詳細を非表示',
  choices_Item: '項目',
  choices_Choice: '選択オプション',
  matrix_column: '列',
  matrix_row: '行',
  multipletext_itemname: 'テキスト',
  savingData: '結果を保存中...。',
  savingDataError: 'エラーが発生し、結果を保存できませんでした。',
  savingDataSuccess: '結果が正常に保存されました',
  savingExceedSize: '回答は 64 KB を超えています。ファイルのサイズを小さくしてもう一度お試しいただくか、アンケートの作成者にお問い合わせください。',
  saveAgainButton: 'もう一度試してみてください。',
  timerMin: '僅少',
  timerSec: 'セック',
  timerSpentAll: 'あなたはこのページに{0}を費やし、合計で{1}を費やしました。',
  timerSpentPage: 'あなたはこのページに{0}を費やしました。',
  timerSpentSurvey: '合計で{0}を使ったことになります。',
  timerLimitAll: 'このページに{1}のうち{0}を費やし、{3}のうち{2}を合計で費やしました。',
  timerLimitPage: 'このページで{1}の{0}を使ったことがあります。',
  timerLimitSurvey: '合計で{1}の{0}を使ったことがあります。',
  clearCaption: '空白',
  signaturePlaceHolder: 'ここに署名',
  signaturePlaceHolderReadOnly: '署名なし',
  chooseFileCaption: 'ファイルを選択',
  takePhotoCaption: '写真を撮る',
  photoPlaceholder: '下のボタンをクリックしてカメラで写真を撮影してください。',
  fileOrPhotoPlaceholder: 'ファイルをドラッグ＆ドロップまたは選択してアップロードするか、カメラで写真を撮影してください。',
  replaceFileCaption: 'ファイルを置換',
  removeFileCaption: 'このファイルを削除',
  booleanCheckedLabel: 'はい',
  booleanUncheckedLabel: 'いいえ',
  confirmRemoveFile: 'このファイルを削除してもよろしいですか？{0}?',
  confirmRemoveAllFiles: 'すべてのファイルを削除してもよろしいですか？',
  questionTitlePatternText: '質問のタイトル',
  modalCancelButtonText: 'キャンセル',
  modalApplyButtonText: '申し込む',
  filterStringPlaceholder: '検索するタイプ...',
  emptyMessage: '表示するデータがありません',
  loadingPage: '積載。。。',
  loadingData: '積載。。。',
  noEntriesText: 'エントリはまだありません。\n下のボタンをクリックして、新しいエントリを追加します。',
  noEntriesReadonlyText: 'エントリはありません。',
  tabTitlePlaceholder: '新しいパネル',
  more: '続きを見る',
  tagboxDoneButtonCaption: 'わかりました',
  selectToRankEmptyRankedAreaText: 'すべての選択肢がランク付けされます',
  selectToRankEmptyUnrankedAreaText: 'ここに選択肢をドラッグアンドドロップしてランク付けします',
  ok: 'わかりました',
  cancel: 'キャンセル',
  createCustomItem: '「{0}」アイテムを作成...',
}
